<template>
	<div class="app-footer">
		<AppDropdown
			class="app-footer__language"
			display-prop="text"
			:value="selectedLanguage"
			@input="setLanguage"
			:options="languages"
			required
		>
			<template #selected="{props}">

				<span class="option-text">
					{{props.option.text}}
				</span>
			</template>
			<template #option="{props}">

				<span class="option-text">
					{{props.option.text}}
				</span>
			</template>
		</AppDropdown>

		<ul
			class="links"
		>
			<li class="links__link">
				<a href="https://www.upmood.com/termsconditions" target="_blank">
					{{ $t('terms_condition') }}
				</a>
			</li>
			<li class="links__link">
				<a href="https://www.upmood.com/privacypolicy" target="_blank">
					{{ $t('privacy_policy') }}
				</a>
			</li>
		</ul>
	</div>
</template>

<script>
import Cookies from 'js-cookie'
import { mapGetters } from 'vuex'

export default {
	data () {
		return {
			languages: [
				{value: 'en', text: 'english'},
				{value: 'ja', text: '日本語'},
				{value: 'ch', text: '中文'}
			],
			languageIcon: {
				en: require('@/assets/img/flag-english.png'),
				ja: require('@/assets/img/flag-japanese.png'),
				ch: require('@/assets/img/flag-china.png')
			}
		}
	},

	computed: {
		...mapGetters({
			isLoggedIn: 'getLoggedInState'
		}),

		selectedLanguage () {
			const lang = this.$i18n.locale
			return this.languages.filter(i => i.value === lang)[0]
		}
	},

	methods: {
		async setLanguage (language) {
			if (this.selectedLanguage === language) return
			this.$i18n.locale = language.value
			Cookies.set('locale', language.value)
		}
	}
}
</script>

<style lang="scss" scoped>
.app-footer {
	padding: 10px 0;
	display: inline-block;

	&__language {
		.icon {
			height: 1em;
		}

		.option-text {
			text-transform: capitalize;
			color: #BFCCE2;
		}

		/deep/ .app-dropdown {
			&__toggle {
				background-color: transparent;
				border: none;
				padding: 0;
			}
		}
	}

	.links {
		list-style-position: inside;
		display: inline-flex;
		color: #BFCCE2;

		a {
			color: #BFCCE2;
			text-decoration: none;
		}

		&__link {
			margin-left: 10px;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/app-components/AppFooter.vue